export default "__VITE_ASSET__0we4JdbL__"